import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';


@Component({
  selector: 'app-invoice-form-list',
  templateUrl: './invoice-form-list.component.html',
  styleUrl: './invoice-form-list.component.css'
})
export class InvoiceFormListComponent implements AfterViewInit {
  displayedColumns: string[] = ['invoiceNumber', 'type', 'date', 'amount', 'status', 'actions'];
  dataSource = new MatTableDataSource<any>([
    {
      invoiceNumber: 'INV-001',
      type: 'Partial',
      date: '2025-10-25',
      amount: 4000,
      status: 'Paid',
      customerName: 'CFI Technology Pvt Ltd',
      customerAddress: '83/2 D Sector, Kolar, Bhopal, Madhya Pradesh, India',
    },
    {
      invoiceNumber: 'INV-002',
      type: 'Final',
      date: '2025-10-26',
      amount: 4000,
      status: 'Pending',
      customerName: 'CFI Technology Pvt Ltd',
      customerAddress: '83/2 D Sector, Kolar, Bhopal, Madhya Pradesh, India',
    }
  ]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // downloadPDF(row: any) {
  //   const doc = new jsPDF();
    
  //   doc.text('Invoice Details', 10, 10);
  //   doc.autoTable({ html: '#invoice-table' });
  //   doc.text(`Invoice Number: ${row.invoiceNumber}`, 10, 30);
  //   doc.text(`Type: ${row.type}`, 10, 40);
  //   doc.text(`Date: ${row.date}`, 10, 50);
  //   doc.text(`Amount: ${row.amount}`, 10, 60);
  //   doc.text(`Status: ${row.status}`, 10, 70);
  //   doc.save(`${row.invoiceNumber}.pdf`);
  // }
//   downloadPDF(invoice: any) {
//   const doc = new jsPDF();

//   doc.setFontSize(18);
//   doc.text('Invoice', 14, 22);

//   doc.setFontSize(12);
//   doc.text(`Invoice Number: ${invoice.invoiceNumber}`, 14, 32);
//   doc.text(`Date: ${invoice.date}`, 14, 40);
//   doc.text(`Type: ${invoice.type}`, 14, 48);
//   doc.text(`Amount: $${invoice.amount}`, 14, 56);
//   doc.text(`Status: ${invoice.status}`, 14, 64);

//   autoTable(doc, {
//     startY: 70,
//     head: [['Item', 'Qty', 'Price']],
//     body: [
//       ['Service A', '1', '$1000'],
//       ['Service B', '2', '$3000'],
//     ]
//   });

//   doc.save(`${invoice.invoiceNumber}.pdf`);
// }


downloadPDF(invoice: any) {
  const doc = new jsPDF();

  // Header
  doc.setFontSize(22);
  doc.setTextColor(40);
  doc.text('INVOICE', 105, 20, { align: 'center' });

  // Company Info
  doc.setFontSize(10);
  doc.text('SigmaTConflux Infrastructure Project', 14, 30);
  doc.text('83/2 D Sector, Kolar', 14, 35);
  doc.text('Bhopal, MP 462001', 14, 40);
  doc.text('Phone: +91 8878857588', 14, 45);

  // // Invoice Details
  // doc.setFontSize(12);
  // doc.text(`Invoice #: ${invoice.invoiceNumber}`, 150, 30);
  // doc.text(`Date: ${invoice.date}`, 150, 35);
  // // doc.text(`Status: ${invoice.status}`, 150, 40);
  // doc.text(`Amount: $${invoice.amount}`, 150, 45);

  // // Customer Info
  // doc.setFontSize(11);
  // doc.text('Bill To:', 14, 60);
  // doc.text(`${invoice.customerName}`, 14, 65);
  // doc.text(`${invoice.customerAddress}`, 14, 70);

  // // Table
  // autoTable(doc, {
  //   startY: 80,
  //   head: [['Description', 'Qty', 'Unit Price', 'Total']],
  //   body: [
  //     ['Consulting Services', '10', '$100', '$1000'],
  //     ['Development Work', '20', '$150', '$3000'],
  //   ],
  //   styles: { fontSize: 10 },
  //   theme: 'striped',
  // });
  // Invoice Details
doc.setFontSize(12);
doc.text(`Invoice #: ${invoice.invoiceNumber}`, 150, 30);
doc.text(`Date: ${invoice.date}`, 150, 35);
// doc.text(`Status: ${invoice.status}`, 150, 40);
// Use '₹' for the main invoice amount
doc.text(`Amount: Rs.${invoice.amount}`, 150, 45);

// Customer Info
doc.setFontSize(11);
doc.text('Bill To:', 14, 60);
doc.text(`${invoice.customerName}`, 14, 65);
doc.text(`${invoice.customerAddress}`, 14, 70);

// Table
autoTable(doc, {
  startY: 80,
  head: [['Description', 'Qty', 'Unit Price', 'Total']],
  body: [
    // Use '₹' in the table data
    ['Consulting Services', '10', 'Rs.100', 'Rs.1000'],
    ['Development Work', '20', 'Rs.150', 'Rs.3000'],
  ],
  styles: { fontSize: 10 },
  theme: 'striped',
});

  // Footer
  doc.setFontSize(10);
  doc.text('Thank you for your business!', 105, doc.internal.pageSize.height - 10, {
    align: 'center',
  });

  doc.save(`Invoice-${invoice.invoiceNumber}.pdf`);
}

}
